/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { SurveyMarkDetailsDto } from '../../models/survey-mark-details-dto';

export interface GetSurveyMarkDetails$Params {
  id: string;
}

export function getSurveyMarkDetails(
  http: HttpClient,
  rootUrl: string,
  params: GetSurveyMarkDetails$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<SurveyMarkDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getSurveyMarkDetails.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SurveyMarkDetailsDto>;
      }),
    );
}

getSurveyMarkDetails.PATH = '/surveyMarks/details/{id}';
